import type { ActivatedDrawId, retailerBalanceApiResponse } from '../../../../schema/marketplace/entry.js';
import type { IAuthorizedUseCase, IGetRetailerBalanceUseCase } from '../../../domain/entry.js';

export type IGetRetailerBalanceController = ReturnType<typeof getRetailerBalanceController>;
type RetailerBalanceResponse = Extract<
  ReturnType<(typeof retailerBalanceApiResponse)['parse']>,
  { data: object }
>['data'];

type GetRetailerBalanceControllerParams = {
  activatedDrawId: ActivatedDrawId;
};

/**
 * Creates a controller for retrieving retailer balance.
 *
 * @param getRetailerBalanceUseCase - The use case for getting retailer balance
 * @param authorizedUseCase - The use case for checking user roles
 * @returns A controller function that executes the retailer balance use case
 */
export function getRetailerBalanceController(
  getRetailerBalanceUseCase: IGetRetailerBalanceUseCase,
  authorizedUseCase?: IAuthorizedUseCase
) {
  return async function controller({
    activatedDrawId,
  }: GetRetailerBalanceControllerParams): Promise<RetailerBalanceResponse | { activatedDraw: undefined }> {
    let isUserRole = true;
    // Only able to check user role server side.
    if (authorizedUseCase) {
      isUserRole = await authorizedUseCase.execute({ role: 'Retailer' });
    }
    if (!isUserRole) {
      return { activatedDraw: undefined };
    }
    return await getRetailerBalanceUseCase.execute({ activatedDrawId });
  };
}
